import { Stack, IconButton, Link } from '@mui/material';

import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';

export default function SocialMedia() {
    return (
        <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} sx={{ p: 1 }}>
            <IconButton component={Link} href={"https://www.youtube.com/channel/UCIHlmfSvQE_oMQB8-CqsZuQ"} target='_blank'>
                <YouTubeIcon sx={{ color: "#FF0000" }} />
            </IconButton>
            <IconButton component={Link} href={"https://www.instagram.com/aimscs/"} target='_blank'>
                <InstagramIcon sx={{ color: "#E1306C" }} />
            </IconButton>
            <IconButton component={Link} href={"https://www.linkedin.com/company/cr-rao-aimscs/"} target='_blank'>
                <LinkedInIcon sx={{ color: "#0077b5" }} />
            </IconButton>
            <IconButton component={Link} href={"https://www.facebook.com/people/C-R-Rao-Advanced-Institute-of-Mathematics-Statistics-and-Computer-Science/100070068110483/"} target='_blank'>
                <FacebookIcon sx={{ color: "#316FF6" }} />
            </IconButton>
        </Stack>
    )
}